import { Model } from "@vuex-orm/core";

export default class CompanySetting extends Model {
  static entity = "companySettings";
  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      key: this.attr(null),
      value: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(null),
    }
  }

  static getLatLngBase() {
      let lat = null
      let lng = null

      const companySettings = CompanySetting
        .query()
        .where(record => record.key === 'baseLat' || record.key === 'baseLng')
        .get()

      if(companySettings.length)
          companySettings.forEach(companySetting => {
              if(companySetting.key === 'baseLat')
                  lat = parseFloat(companySetting.value)
              if(companySetting.key === 'baseLng')
                  lng = parseFloat(companySetting.value)
          })
          
      return {
          lat,
          lng
      }
  }

}
